import { render } from "./PanelTipsterMetodosPago.vue?vue&type=template&id=a93f4b2e&scoped=true"
import script from "./PanelTipsterMetodosPago.vue?vue&type=script&lang=js"
export * from "./PanelTipsterMetodosPago.vue?vue&type=script&lang=js"

import "./PanelTipsterMetodosPago.vue?vue&type=style&index=0&id=a93f4b2e&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a93f4b2e"]])

export default __exports__